// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-wrapper {
  margin: 0 -15px;
  padding: 60px 15px;
}
.section-wrapper.dark {
  background-color: #80808038;
}
.section-header {
  display: flex;
  margin-bottom: 10px;
}
.section-title {
  margin-top: 0;
  flex-basis: auto;
  flex-grow: 1;
  flex-shrink: 1;
}
.section-title-action-container {
  flex-basis: auto;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: 20px;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
